const defaultThemes = [
    {
        id: 1,
        src: '1.jpg',
        premium: false
    },
    {
        id: 2,
        src: '2.jpg',
        premium: false
    },
    {
        id: 3,
        src: '3.jpg',
        premium: false
    },
    {
        id: 4,
        src: '4.jpg',
        premium: false
    },
    {
        id: 5,
        src: '5.jpg',
        premium: true
    },
    {
        id: 6,
        src: '6.jpg',
        premium: true
    }
];
export default defaultThemes;
